var _style, _path, _rect, _polygon, _polygon2, _path2, _rect2, _path3, _polygon3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _polygon4, _polygon5, _polygon6, _path10, _path11, _path12, _path13, _path14, _path15, _polygon7, _polygon8, _polygon9, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdityaBirlaGroupSeeklogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AB1F24;}\n\t.st1{fill:#EF7032;}\n\t.st2{fill:#FFD35D;}\n\t.st3{fill:#D31F26;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,446H61.6v40.8h11.2c13,0,21.4-8,21.4-20.4S85.8,446,72.8,446 M69.3,453.4h3.2c8.9,0,13.8,4.6,13.8,13 c0,8.4-4.9,13-13.8,13h-3.2V453.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 446,
    className: "st0",
    width: 7.8,
    height: 40.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "117.8,453.4 129.2,453.4 129.2,486.8 136.9,486.8 136.9,453.4 148.2,453.4 148.2,446 117.8,446 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "178.3,446 168.9,462.3 159.4,446 150.6,446 165,470.6 165,486.8 172.7,486.8 172.7,470.6 186.9,446 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.1,465.2c1.9-1.9,2.9-4.5,2.9-7.7c0-7-4.9-11.5-12.6-11.5h-14.4v40.8h15.2c8.3,0,13.6-4.8,13.6-12.2 C272.8,470.5,271.2,467.2,268.1,465.2 M258.1,453.3c3.5,0,5.2,1.4,5.2,4.4c0,3-1.4,4.4-4.6,4.4h-7v-8.8H258.1z M251.8,469.3h7 c4.1,0,6.3,1.7,6.3,5.1c0,3.4-2,5.1-6.2,5.1h-7.1V469.3z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 281.2,
    y: 446,
    className: "st0",
    width: 7.8,
    height: 40.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,459c0-7.8-5.7-13-14.3-13h-13v40.8h7.7v-14.9h4.9l9.2,14.9h8.9l-10.3-16.5 C324.6,468.2,327.1,464.2,327.1,459 M307.4,453.4h5.1c4.5,0,6.7,1.9,6.7,5.7c0,2.4-0.7,5.5-6.7,5.5h-5.1V453.4z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "344,446 336.2,446 336.2,486.8 360.9,486.8 360.9,479.5 344,479.5 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.3,471.9h11v5.2c-2.3,1.7-5.3,2.5-9,2.5c-7.7,0-13.3-5.6-13.3-13.4s5.3-13.4,12.7-13.4c5.4,0,8,2.1,9.8,4.1 l1.4,1.6l5.5-5.2l-1.4-1.5c-3.9-4.3-8.9-6.4-15.3-6.4c-11.6,0-20.7,9.1-20.7,20.8c0,11.9,9.1,20.8,21.2,20.8 c6.5,0,11.5-1.8,15.9-5.6l0.7-0.6v-16.2h-18.6V471.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.1,458.8c0-7.8-5.7-13-14.3-13h-13v40.8h7.7v-14.9h4.9l9.2,14.9h8.9l-10.3-16.5 C494.6,468,497.1,463.9,497.1,458.8 M477.5,453.1h5.1c4.5,0,6.6,1.9,6.6,5.7c0,2.4-0.7,5.5-6.6,5.5h-5.1V453.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.7,445.4c-11.7,0-20.8,9.1-20.8,20.8S513,487,524.7,487c11.7,0,20.9-9.1,20.9-20.8S536.4,445.4,524.7,445.4  M524.7,479.6c-7.5,0-13-5.6-13-13.4s5.5-13.4,13-13.4c7.5,0,13,5.6,13,13.4S532.2,479.6,524.7,479.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.7,471.8c0,5.2-2.5,7.8-7.3,7.8c-4.8,0-7.3-2.7-7.3-7.8v-26h-7.7v26.2c0,9.1,5.9,14.9,15,14.9 c9.1,0,15-5.9,15-14.9v-26.2h-7.7V471.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.5,445.8h-12.9v40.8h7.7V472h5.1c8.7,0,14.3-5.1,14.3-13.1C620.8,451,615.2,445.8,606.5,445.8 M601.4,453.1 h4.9c4.5,0,6.6,1.9,6.6,5.8c0,3.9-2.2,5.7-6.6,5.7h-4.9V453.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,486.7h7.6l3.4-8.4h12.8l3.4,8.4h7.7l-17.4-42.2L20.8,486.7z M34.6,471.4l3.6-8.9l3.6,8.9H34.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.1,486.8h7.6l3.3-8.4h12.8l3.4,8.4h7.7l-17.4-42.2L184.1,486.8z M197.8,471.6l3.6-8.9l3.6,8.9H197.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365.8,486.7h7.6l3.4-8.4h12.8l3.4,8.4h7.7l-17.4-42.2L365.8,486.7z M379.5,471.4l3.6-8.9l3.6,8.9H379.5z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "528.9,319.6 472.7,345.5 411,268.6 479.9,156.3 528.9,156.3 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "528.9,415.5 528.9,319.6 472.7,345.5 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "411,268.6 320.8,156.3 479.9,156.3 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.2,309l24.7-40.3l-90.1-112.3v134.5l0.6,0C345.2,290.8,367.4,297.5,386.2,309"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.4,290.8h-0.6v124.7L386.2,309C367.3,297.5,345.2,290.8,321.4,290.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M434.6,363.1l38.1-17.6L411,268.6L386.2,309C407.2,321.8,424.1,340.6,434.6,363.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.2,309l-65.4,106.6l113.8-52.5C424.1,340.6,407.2,321.8,386.2,309"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472.7,345.5l-38.1,17.6c7.4,15.9,11.6,33.7,11.6,52.5h82.7L472.7,345.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.8,415.5h125.3c0-18.7-4.1-36.5-11.5-52.5L320.8,415.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112.8,319.6 169,345.5 230.7,268.6 161.8,156.3 112.8,156.3 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "112.8,415.5 112.8,319.6 169,345.5 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "230.7,268.6 320.8,156.3 161.8,156.3 "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.4,309l-24.7-40.3l90.1-112.3v134.5l-0.6,0C296.5,290.8,274.3,297.5,255.4,309"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.2,290.8h0.6v124.7L255.5,309C274.3,297.5,296.5,290.8,320.2,290.8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.1,363.1L169,345.5l61.7-76.9l24.7,40.3C234.4,321.8,217.5,340.6,207.1,363.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.4,309l65.4,106.6l-113.7-52.5C217.5,340.6,234.4,321.8,255.4,309"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169,345.5l38.1,17.6c-7.4,15.9-11.6,33.7-11.6,52.5h-82.7L169,345.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.8,415.5H195.5c0-18.7,4.1-36.5,11.6-52.5L320.8,415.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdityaBirlaGroupSeeklogo);
export default __webpack_public_path__ + "static/media/aditya-birla-group-seeklogo.440cdfe5938dfd970a78d6066d943469.svg";
export { ForwardRef as ReactComponent };